import React from 'react';
import './Loaders.css';

const AutoFillLoader = ({ message = 'AI Analyzing Product' }) => {
  return (
    <div className="autofill-loader-overlay">
      <div className="autofill-loader-content">
        {/* AI Icon with Glow - Sparkles/Magic Wand */}
        <div className="ai-icon-container">
          <div className="ai-icon">
            <svg width="60" height="60" viewBox="0 0 60 60" fill="none">
              {/* Magic Wand */}
              <path d="M15 45 L45 15" stroke="url(#gradient)" strokeWidth="3" strokeLinecap="round" />
              <circle cx="45" cy="15" r="3" fill="url(#gradient)" />

              {/* Sparkles */}
              <path d="M20 20 L20 28 M16 24 L24 24" stroke="url(#gradient)" strokeWidth="2" strokeLinecap="round" />
              <path d="M40 35 L40 43 M36 39 L44 39" stroke="url(#gradient)" strokeWidth="2" strokeLinecap="round" />
              <path d="M50 30 L50 35 M48 32.5 L52 32.5" stroke="url(#gradient)" strokeWidth="1.5" strokeLinecap="round" />
              <path d="M25 50 L25 55 M23 52.5 L27 52.5" stroke="url(#gradient)" strokeWidth="1.5" strokeLinecap="round" />

              <defs>
                <linearGradient id="gradient" x1="0%" y1="0%" x2="100%" y2="100%">
                  <stop offset="0%" stopColor="#6a1b9a" />
                  <stop offset="100%" stopColor="#9c27b0" />
                </linearGradient>
              </defs>
            </svg>
          </div>
        </div>

        {/* Loading Text */}
        <div className="autofill-text">
          <h3 className="autofill-title">{message}<span className="ellipsis"></span></h3>
          <p className="autofill-subtitle">Please wait while AI analyzes your product</p>
        </div>

        {/* Loading Spinner */}
        <div className="loader-spinner"></div>
      </div>
    </div>
  );
};

export default AutoFillLoader;
